import { io } from "socket.io-client";
import config from "../../config.json";

// Must match REST base (`config.dev`). Hardcoding production here breaks local dev:
// orders are created on localhost but sockets listened on prod → live updates never arrive.
const socket = io(config.dev, {
  transports: ["websocket", "polling"],
});

export const asSocketId = (value) => {
  if (!value) return "";
  if (typeof value === "object") return String(value._id || value.id || "").trim();
  const id = String(value).trim();
  return id === "[object Object]" ? "" : id;
};

export const joinRestaurantRoom = (restaurantId) => {
  const id = asSocketId(restaurantId);
  if (!id) return;
  socket.emit("join-restaurant", id);
};

export const joinSupportRoom = (ticketId) => {
  const id = asSocketId(ticketId);
  if (!id) return;
  socket.emit("join-support", id);
};

export default socket;
